import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './shared/interceptors/http.interceptor';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([httpInterceptor])),
    MessageService,
    DialogService,
    providePrimeNG({
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: {
              50: '{amber.50}',
              100: '{amber.100}',
              200: '{amber.200}',
              300: '{amber.300}',
              400: '{amber.400}',
              500: '#ff9300',
              600: '{amber.600}',
              700: '{amber.700}',
              800: '{amber.800}',
              900: '{amber.900}',
              950: '{amber.950}',
            },
          },
        }),
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
  ],
};
